module.exports = __webpack_public_path__ + "static/media/ic_arrowRightWhite.912bbffa.svg";